import Styles from "../AnonForms.module.css";

function WitnessInfo({ 
  witness, 
  createInput 
}) {
  return (
    <div className={`${Styles.fadeIn} ${Styles.groupedInputs}`}>
      <div className={Styles.labelContainer} style={{ width: "7rem" }}>
        <p className={Styles.label}>Witness</p>
      </div>

      <div className={Styles.witnessInfo}>
        {createInput(
          witness.firstName,
          "100%",
          `${Styles.witnessInput} ${Styles.anonInput}`
          )}
      </div>
      <div className={Styles.witnessInfo}>
        {createInput(witness.lastName, "100%", `${Styles.witnessInput} ${Styles.anonInput}`)}
      </div>
      <div className={Styles.witnessInfo}>
        {createInput(witness.witnessPhone, "100%", `${Styles.witnessInput} ${Styles.anonInput}`)}
      </div>
    </div>
  );
}

export default WitnessInfo;
